import {Component} from 'react'
import Cookie from 'js-cookie'

import {
  ErrMsg,
  LoginBtn,
  CheckLabel,
  CheckBoxInput,
  CheckboxContainer,
  FormContainer,
  LoginBgContainer,
  LogoImg,
  InputContainer,
  Label,
  InputEle,
} from './styledComponents'

class Login extends Component {
  state = {
    usernameInp: '',
    passwordInp: '',
    isPasswordShown: false,
    errMsg: '',
  }

  onSubmitForm = async event => {
    event.preventDefault()
    const {usernameInp, passwordInp} = this.state
    const userDetails = {
      username: usernameInp,
      password: passwordInp,
    }
    const options = {
      method: 'POST',
      body: JSON.stringify(userDetails),
    }
    const response = await fetch('https://apis.ccbp.in/login', options)
    const data = await response.json()
    if (response.ok) {
      Cookie.set('jwt_token', data.jwt_token, {expires: 1})
      const {history} = this.props
      history.replace('/')
    } else {
      this.setState({errMsg: data.error_msg})
    }
  }

  onChangeUsername = event => this.setState({usernameInp: event.target.value})

  onChangePassword = event => this.setState({passwordInp: event.target.value})

  onClickShowPassword = () =>
    this.setState(prevState => ({isPasswordShown: !prevState.isPasswordShown}))

  render() {
    if (Cookie.get('jwt_token') !== undefined) {
      const {history} = this.props
      history.replace('/')
    }
    const {usernameInp, passwordInp, isPasswordShown, errMsg} = this.state
    const passType = isPasswordShown ? 'text' : 'password'
    return (
      <LoginBgContainer>
        <FormContainer onSubmit={this.onSubmitForm}>
          <LogoImg
            src="https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-light-theme-img.png"
            alt="website logo"
          />
          <InputContainer>
            <Label htmlFor="username">USERNAME</Label>
            <InputEle
              value={usernameInp}
              type="text"
              onChange={this.onChangeUsername}
              id="username"
              placeholder="rahul"
            />
          </InputContainer>
          <InputContainer>
            <Label htmlFor="password">PASSWORD</Label>
            <InputEle
              value={passwordInp}
              type={passType}
              onChange={this.onChangePassword}
              id="password"
              placeholder="rahul@2021"
            />
          </InputContainer>
          <CheckboxContainer>
            <CheckBoxInput
              onClick={this.onClickShowPassword}
              type="checkbox"
              id="showPassword"
            />
            <CheckLabel htmlFor="showPassword">Show Password</CheckLabel>
          </CheckboxContainer>
          <LoginBtn type="submit">Login</LoginBtn>
          {errMsg !== '' ? <ErrMsg>*{errMsg}</ErrMsg> : null}
        </FormContainer>
      </LoginBgContainer>
    )
  }
}
export default Login
